import Vue from 'vue'
import Vuex from 'vuex'
import { login } from '@/api/login' // 登录API
import { setCookie, getCookie, removeCookie } from '@/utils/utils' // 登录API
import { eventBus } from '@/utils/eventBus'
import { isFromCrmFamily } from '@/utils/formAppInfo'
Vue.use(Vuex)

let userInfo = ''
if (localStorage.getItem('userInfo') && localStorage.getItem('userInfo') != 'undefined') {
    userInfo = localStorage.getItem('userInfo')
        ? JSON.parse(localStorage.getItem('userInfo') || '') || null
        : '' // 先从缓存中获取用户信息，没有则置空
}

export default new Vuex.Store({
    state: {
        // 登录信息状态
        loginInfo: {
            token: localStorage.getItem('token') || '', // 从本地存储获取token，实现刷新页面不丢失
            userInfo: userInfo,
        },
        isLogin: false, // 是否登录
        // 登录后要去的全路径，例如 /vip
        wantedRoute: null,
    },
    mutations: {
        // 设置登录信息
        SET_LOGIN_INFO(state, { token, userInfo }) {
            state.loginInfo.token = token
            state.loginInfo.userInfo = userInfo
            state.isLogin = true

            // 同时存入localStorage，实现持久化
            localStorage.setItem('token', token)
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            // setCookie("token", token);
        },

        // 清除登录信息（退出登录）
        CLEAR_LOGIN_INFO(state) {
            state.loginInfo.token = ''
            state.loginInfo.userInfo = null
            state.isLogin = false

            // 清除localStorage
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
            localStorage.removeItem('currentMapInfo') // 清除当前所选地区信息
            // removeCookie("token");
        },
        // 设置想要跳转的路由
        SET_WANTED_ROUTE(state, path) {
            state.wantedRoute = path
            localStorage.setItem('wantedRoute', path)
        },
        // 清空想要跳转的路由
        CLEAR_WANTED_ROUTE(state) {
            state.wantedRoute = null
            localStorage.removeItem('wantedRoute')
        },
    },
    actions: {
        // 登录操作
        async loginAction({ commit }, loginData) {
            try {
                const { token, userInfo } = loginData
                // 提交mutation设置登录信息
                commit('SET_LOGIN_INFO', { token, userInfo })
                return true
            } catch (error) {
                console.error('登录失败:', error)
                return false
            }
        },
        // 退出登录
        logout({ commit }) {
            // 提交mutation清除登录信息
            commit('CLEAR_LOGIN_INFO')
            commit('CLEAR_WANTED_ROUTE')
            /* 接入微观E家：子应用退出登录时、通过参数传递通知父应用，由父应用操作登出事件 */
            if (isFromCrmFamily())
                return window.ipcRenderer.send('subApp:logout', { subAppName: 'PORTAL' })
            eventBus.$emit('showLogin', true) // 触发登录弹窗
            // 返回一个成功的Promise
            return Promise.resolve()
        },
        // 保存目标路由地址
        saveWantedRoute({ commit }, path) {
            commit('SET_WANTED_ROUTE', path)
        },
        // 消毁并返回路径
        pickWantedRoute({ state, commit }) {
            const path = state.wantedRoute
            commit('CLEAR_WANTED_ROUTE')
            return path
        },
    },
    getters: {
        // 获取登录信息的快捷方式
        token: state => state.loginInfo.token,
        userInfo: state => state.loginInfo.userInfo,
        isLogin: state => state.isLogin,
        wantedRoute: state => state.wantedRoute,
    },
})
